import { useQuery } from "@tanstack/react-query";
import { applicationService } from "@/services/application.service";

export const SUBJECT_PERFORMANCE_STALE_MS = 1000 * 60 * 5;

export function subjectPerformanceQueryKey(
	applicationId: string,
	subjectId: string,
) {
	return ["subjectPerformance", applicationId, subjectId] as const;
}

export function useSubjectPerformance(
	applicationId: string,
	subjectId: string,
) {
	return useQuery({
		queryKey: subjectPerformanceQueryKey(applicationId, subjectId),
		queryFn: () =>
			applicationService().getSubjectPerformance(applicationId, subjectId),
		enabled: !!applicationId && !!subjectId,
		staleTime: SUBJECT_PERFORMANCE_STALE_MS,
	});
}
